import template from './thumbnail.dot';
const thumbnailTemplate = template.default ? template.default : template;
export { thumbnailTemplate };
